export default __webpack_public_path__ + "locales/hy-AM/Files.json?hash=52a6692eb81e8c50778956c57561018b";